// extracted by mini-css-extract-plugin
export default {"container":"SmallBox_container__ZF-jJ","text":"SmallBox_text__z7RxN","icon":"SmallBox_icon__ajfc4"};